<button class="auth-button-base" [disabled]="loader()">
  <div class="auth-button__icon-wrapper">
    @if (!loader()) {
      <img [src]="data().icon" [alt]="data().alt" />
    } @else {
      <span class="spinner-border spinner-border-sm spinner" role="status" aria-hidden="true"></span>
    }
  </div>
  <span class="auth-button__text" [translate]="data().text"></span>
</button>

